var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0683594 1.875C0.0683594 1.11561 0.683968 0.5 1.44336 0.5H4.40356C5.07571 0.5 5.64935 0.985943 5.75985 1.64895L6.77641 7.74828C6.87564 8.3437 6.57494 8.93421 6.03503 9.20416L3.90634 10.2685C5.44125 14.0827 8.48567 17.1271 12.2999 18.662L13.3642 16.5333C13.6341 15.9934 14.2247 15.6927 14.8201 15.792L20.9194 16.8085C21.5824 16.919 22.0684 17.4926 22.0684 18.1648V21.125C22.0684 21.8844 21.4528 22.5 20.6934 22.5H17.9434C8.07127 22.5 0.0683594 14.4971 0.0683594 4.625V1.875Z",
    fill: "#f58612"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCallIcon);
export default __webpack_public_path__ + "static/media/orange-call-icon.363c59089940aa9d1fc0f964f4665d08.svg";
export { ForwardRef as ReactComponent };